import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { LookupTransformation } from 'app/model/dataflow/lookuptransformation';
import { BaseMultiInputStreamTransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-multi-input-stream-transformation.adapter';
import { DataFlowExpressionUtils } from '../expression.util';
import { BooleanDataFlowType, StringDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LookupTransformation),
    asynchronous: true
})
export class LookupTransformationAdapter extends BaseMultiInputStreamTransformationAdapter {
    protected getTransformationName(): string {
        return 'lookup';
    }

    protected getExpressionScript(transformation: LookupTransformation): string {
        const props = [];
        props.push(
            `multiple: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                transformation.multipleRow,
                BooleanDataFlowType.TYPE
            )}`
        );
        if (transformation.multipleRow.expression !== 'true') {
            props.push(
                `pickup: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    transformation.pickupRow,
                    StringDataFlowType.TYPE
                )}`
            );
            if (transformation.pickupRow.expression !== 'any') {
                const sorts = transformation.sortExpressions.map((sortExpression) => {
                    // eslint-disable-next-line max-len
                    return `${
                        sortExpression.ascending ? 'asc' : 'desc'
                    }(${DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
                        sortExpression.dataFlowExpression.expression
                    )}, ${sortExpression.nullsFirst ? 'true' : 'false'})`;
                });
                props.push(...sorts);
            }
        }
        const expressionScript = props.join(',\n\t');
        return expressionScript
            ? `${super.getExpressionScript(transformation)},\n\t${expressionScript}`
            : super.getExpressionScript(transformation);
    }
}
